'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

interface WatermarkContextType {
  isVisible: boolean;
  toggle: () => void;
  setVisible: (visible: boolean) => void;
}

const WatermarkContext = createContext<WatermarkContextType | undefined>(undefined);

const STORAGE_KEY_VISIBILITY = 'watermark_visibility';

export function WatermarkProvider({ children }: { children: React.ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);

  // Загружаем сохраненное состояние при монтировании
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(STORAGE_KEY_VISIBILITY);
      if (saved !== null) {
        setIsVisible(JSON.parse(saved));
      }
    }
  }, []);

  // Сохраняем состояние в localStorage
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY_VISIBILITY, JSON.stringify(isVisible));
    }
  }, [isVisible]);

  const toggle = () => {
    setIsVisible(prev => !prev);
  };

  const setVisible = (visible: boolean) => {
    setIsVisible(visible);
  };

  return (
    <WatermarkContext.Provider value={{ isVisible, toggle, setVisible }}>
      {children}
    </WatermarkContext.Provider>
  );
}

export function useWatermark() {
  const context = useContext(WatermarkContext);
  if (context === undefined) {
    throw new Error('useWatermark must be used within a WatermarkProvider');
  }
  return context;
}












